import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import { initAuthDefaultFlow } from './auth-flows/default-flow';
import { initAuthLoungePortalFlow } from './auth-flows/lounge-portal-flow';

// Types

/**
 * Auth plugin for Nuxt using Auth0.
 *
 * @param {Context} context
 * @param {Inject} inject
 */
export var auth = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref, inject) {
    var app, $config, route, path, basePath, authFlow, auth;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          app = _ref.app, $config = _ref.$config, route = _ref.route;
          path = window.location.pathname;
          basePath = path.split('/').filter(Boolean)[0];
          _context.t0 = basePath;
          _context.next = _context.t0 === 'lounge-portal' ? 6 : 8;
          break;
        case 6:
          authFlow = initAuthLoungePortalFlow({
            app: app,
            $config: $config,
            route: route
          });
          return _context.abrupt("break", 9);
        case 8:
          authFlow = initAuthDefaultFlow({
            app: app,
            $config: $config,
            route: route
          });
        case 9:
          auth = authFlow;
          _context.next = 12;
          return auth.initAuth();
        case 12:
          inject('auth', auth);
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function auth(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();
export default auth;